enum CurrencyFieldSuffix {
  KR = 'KR',
  KR_PER_YEAR_BEFORE_TAX = 'KR_PER_YEAR_BEFORE_TAX',
  KR_PER_MONTH = 'KR_PER_MONTH',
  KR_PER_MONTH_YOUR_SHARE = 'KR_PER_MONTH_YOUR_SHARE',
  KR_PER_MONTH_BEFORE_TAX = 'KR_PER_MONTH_BEFORE_TAX',
}

export default CurrencyFieldSuffix;
